export const baseUrl = process.env.REACT_APP_API_URL + '/api/v1/' //"http://localhost:3000/api/v1/"; // LOCAL
// export const baseUrl = "https://operation36-dev.herokuapp.com/api/v1/"; // DEV
// export const baseUrl = "https://operation36.herokuapp.com/api/v1/"; // PROD

// this controlls the API calls for the community map since Redux isn't being used and we don't want to redirect anyone to the /log-in page
